"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var classnames_1 = __importDefault(require("classnames"));
var BoxDaEstrela_1 = __importDefault(require("./BoxDaEstrela"));
var lodash_1 = require("lodash");
var Estrela = function (_a) {
  var valor = _a.valor,
    sx = _a.sx,
    _b = _a.tamanho,
    tamanho = _b === void 0 ? 14 : _b,
    _c = _a.quantidadeDeEstrelas,
    quantidadeDeEstrelas = _c === void 0 ? 5 : _c,
    _d = _a.editavel,
    editavel = _d === void 0 ? true : _d,
    _e = _a.selecionado,
    selecionado = _e === void 0 ? false : _e,
    onChange = _a.onChange,
    rest = __rest(_a, ["valor", "sx", "tamanho", "quantidadeDeEstrelas", "editavel", "selecionado", "onChange"]);
  var rangeDeEstrelas = lodash_1.range(1, quantidadeDeEstrelas + 1);
  var _f = react_1.default.useState(null),
    estrelaHovered = _f[0],
    setEstrelaHovered = _f[1];
  var handleOnChange = react_1.default.useCallback(function (i) {
    return function () {
      onChange && onChange(i === valor ? 0 : i);
    };
  }, [valor, onChange]);
  return react_1.default.createElement(BoxDaEstrela_1.default, {
    sx: sx
  }, rangeDeEstrelas.map(function (index) {
    return react_1.default.createElement(react_feather_1.Star, __assign({
      size: tamanho,
      key: index,
      "data-testid": "star-" + index,
      onClick: handleOnChange(index),
      className: classnames_1.default({
        ativo: index <= valor && !estrelaHovered,
        selecionado: selecionado,
        naoEditavel: !editavel,
        hover: estrelaHovered && index <= estrelaHovered
      }),
      onMouseEnter: editavel ? function () {
        return setEstrelaHovered(index);
      } : function () {},
      onMouseLeave: editavel ? function () {
        return setEstrelaHovered(null);
      } : function () {}
    }, rest));
  }));
};
exports.default = Estrela;